module.exports = __webpack_public_path__ + "img/new-icon.e54045f.svg";